/** @jsxImportSource theme-ui */
import { Container } from 'theme-ui';
import CompanyEmbed from '@/containers/companyEmbed/CompanyEmbed';

const CompanyEmbedPage = () => (
    <Container>
        <CompanyEmbed />
    </Container>
);

export default CompanyEmbedPage;
